import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      " Why should I hire TekRevol for mobile app development in Miami?",
    answer: `<p>TekRevol is a leading app development company in Miami crafting digital products for future-oriented enterprises. We help businesses build exceptional digital products, boost productivity, and streamline core business operations using state-of-the-art app design and development practices.</p>`,
  },
  {
    question: "Where are you located?",
    answer: ` <p>We are located at 400 NW 26th St, Miami, Florida 33127</p>`,
  },
  {
    question: " What is the best framework to develop apps?",
    answer: `<p>Flutter and React Native are the best frameworks to develop applications. Both of these frameworks facilitate developers in building Native and cross-platform applications on Android and iOS.</p>`,
  },
  {
    question: "How long does it take to develop a mobile app in Miami?",
    answer: `<p>A mobile application may take three to nine months on average to develop. However, complex applications with advanced features and functionality can even take 18 months to fully develop and get published.</p>`,
  },
  {
    question: "How to find an app developer?",
    answer: ` <p>Our recommendation to startups and corporations is to create a checklist that outlines their project details and the technical requirements or team they require to get started with their mobile application. The stage mentioned above is to be completed before finding an app developer. Also, in your checklist, document the device you want the app for, the technologies you want to use, your allocated budget for app development, and the location you wish to hire from.</p>`,
  },
  {
    question: "Why should I hire a mobile app development company in Miami?",
    answer: ` <p>Hiring a mobile app development company gives a competitive advantage in project management, skills and expertise, professionalism, quality, and much more. These companies have teams with experienced app developers, designers, and testers who can efficiently handle all stages of the app development process.</p>`,
  },
  {
    question: "How much does it cost to build an app?",
    answer: ` <p>The hourly charges of app developers may vary depending on the requirements and scope of your app project.</p>`,
  },
  {
    question: "How do I find the right Mobile App Developers in Miami Near Me?",
    answer: ` <p>You can simply go on Google and search app developers in Miami near me and you’ll have multiple options against your search. After that, you can explore their website and research their existing products. Further, you can contact them on their given contact information to know more about their app development services and consult for your project accordingly</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
